import { GetProfileResponse } from '@features/user/types/get-profile-response';
import { api } from '@src/lib/api-client';
import { queryClient } from '@src/lib/react-query';
import { useSessionStore } from '@src/stores/use-session-store';

const PROBE_DEBOUNCE_MS = 2000;

export type ProbeResult = 'alive' | 'dead';

export async function probeSession(): Promise<ProbeResult> {
  const { lastProbeAt, actions } = useSessionStore.getState();
  const now = Date.now();

  if (lastProbeAt && now - lastProbeAt < PROBE_DEBOUNCE_MS) {
    return 'alive';
  }

  actions.setLastProbeAt(now);

  try {
    const res = await api.get<GetProfileResponse>('/api/v3/user/profile');
    // The probe runs when the user returns to this tab, so it catches another
    // User's sign-in before they try to save, and keeps that User's profile
    // out of the cache.
    if (!actions.rememberUser(res.data.uuid)) {
      actions.markDead('user_changed');
      return 'dead';
    }
    queryClient.setQueryData(['profile'], res.data);
    actions.restartSessionTimeout(res.data.timeoutIn);
    return 'alive';
  } catch {
    actions.markDead();
    return 'dead';
  }
}
